const { detect } = require('detect-browser');
const STORAGE_KEY = "pwa-banner-installed"; // localstorage keyname
import {trackEvent} from "./helpers";

// listner to the install event of PWA
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault(); // block default event
  localStorage.removeItem(STORAGE_KEY); // must run only if the event beforeinstallprompt is supported
  window.deferredInstallPwaPrompt = e; // saved the event for open up later
});

// listener to the event just added because sometimes apps may not be refreshed and cause issue
// so we listen and update property
window.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    if(checkIsApp() || isAppInstalled()) {
        jQuery("#container-pwa").addClass("hidden");
    }
  }
});

// check browser and OS
// by library detect-browser v5.3.0 for more info check out on npm
const browserInfo = detect() || { name: "No browser find"};
switch (browserInfo.name) {
// all chrome based browser support Native PWA and events
// but not all browser had implemented the possibility to install PWA
case "chrome":
case "edge":
case "edge-chromium":
    showCustomBannerWithNativePrompt();
    break;
// all the system IOS support PWA but by with custom special ruels
// all the browser rely on the same rule of Safari
case "safari":
case "ios":
case "crios":
case "fxios":
case "edge-ios":
    showCustomBannerWithOutNativePrompt();
    break;
// should work like chrome and support native PWA with even events
case "samsung":
    showCustomBannerWithNativePrompt();
    break;
// all browser that no support PWA
// Opera (maybe 2027) got support since is chrome based but removed the install option
// Tor
// Vivaldi
// Falkon
// Firefox partial support for PWA not all OS and not all feature included
case "opera":
case "opera-mini":
case "firefox":
default:
    console.warn("No support for PWA on this browser", browserInfo);
}

// show up the banner with the instruction to follow for install PWA
// 99% of the time this will be shown in the IOS mobile system
async function showCustomBannerWithOutNativePrompt() {
    trackEvent("SHOW_BANNER_APP", "Show mobile app banner");
    // since we got no track abount install by user on system without Native prompt
    // check if the dom says is standalone so we know is app
    if(checkIsApp() || isReminderPwaCookieValid()) {
        return;
    }
    const $banner = jQuery("#banner-pwa");
    const $container = jQuery("#container-pwa");
    if ($banner.length && $container.length) {
        $container.removeClass("hidden");
        $banner.addClass("pwa-animation-fade-in");
        $banner.html(`
            <div class="flex flex-col gap-4 relative">
                <img class="img-hand" src="/themes/custom/adoption_management/assets/img/pwa-hand.png">
                <div>
                    <p class="mb-1 text-sm font-semibold text-white">Aggiungi brAIn alla  Home</p>
                    <p id="DescriptionIos" class="text-xs text-white font-medium">Vai su Condividi sul tuo browser e scorri verso il basso. Troverai lì l'opzione!</p>
                </div>
            <div class="flex gap-2">
                <button id="dismiss-btn" type="button" class="text-xs font-semibold text-white rounded-lg border border-white bg-transparent px-[12px] py-[7px]">Non mostrare più</button>
            </div>
        </div>
        `);
        jQuery("#dismiss-btn").on("click", function () {
            dismissBanner();
        });
    }
}

// show up a custom banner and got 2 buttons for close and install the app by the native popup
function showCustomBannerWithNativePrompt() {
    trackEvent("SHOW_BANNER_APP", "Show mobile app banner");
    if(checkIsApp() || isAppInstalled() || isReminderPwaCookieValid()) {
        return;
    }
    const $banner = jQuery("#banner-pwa");
    const $container = jQuery("#container-pwa");
    if ($banner.length && $container.length) {
        $container.removeClass("hidden");
        $banner.addClass("pwa-animation-fade-in");
        $banner.html(`
            <div class="flex flex-col gap-4 relative">
                <img class="img-hand" src="/themes/custom/adoption_management/assets/img/pwa-hand.png">
                <div>
                    <p class="mb-1 text-sm font-semibold text-white">Accedi rapidamente a brAIn dalla schermata Home</p> 
                    <p class="text-xs text-white font-medium">Aggiungilo al tuo dispositivo</p>
                </div>
                <div class="flex gap-2">
                    <button id="dismiss-btn" type="button" class="text-xs font-semibold text-white rounded-lg border border-white bg-transparent px-[12px] py-[7px]">Ricordamelo più tardi</button>
                    <button id="install-btn" type="button" class="text-xs font-semibold text-white rounded-lg px-[12px] py-[7px]">Scarica</button>
                </div>
            </div>
        `);
        jQuery("#install-btn").on("click", async function () {
            if (window.deferredInstallPwaPrompt) {
                trackEvent("CLICK_BANNER_INSTALL", "Click on banner");
                window.deferredInstallPwaPrompt.prompt(); // open native prompt
                const choice = await window.deferredInstallPwaPrompt.userChoice;
                if (choice.outcome === "accepted") {
                    trackEvent("MOBILE_APP_INSTALLED", "App Installed");
                    localStorage.setItem(STORAGE_KEY,"YES");
                    jQuery("#container-pwa").addClass("hidden");
                }
                window.deferredInstallPwaPrompt = null;
            }
        });
        jQuery("#dismiss-btn").on("click", function () {
            dismissBanner();
        });
    }
}

// on dismiss banner we hide the element and set a cookie reminder 7 days
function dismissBanner() {
    setReminderPwaCookie();
    jQuery("#container-pwa").addClass("hidden");
}

// check out the dom for distinguished app from browser
// does may not work on all browser
function checkIsApp() {
 return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
}

function isAppInstalled() {
  return localStorage.getItem(STORAGE_KEY) === "YES";
}

// we set the cookie for the remider evey that exires in 7 days and 8:00 o clock
function setReminderPwaCookie() {
  const expires = new Date();
  expires.setDate(expires.getDate() + 7); // add 7 days from today
  expires.setHours(8, 0, 0, 0); // 8:00 for a simpler use on timezone issue at midnight
  document.cookie = [
    `reminderpwa=true`,
    `expires=${expires.toUTCString()}`,
    `path=/`
  ].join("; ");
}

// we get all the cookie and check if exist or expired
// browser remove automatically the cookie if expired
function isReminderPwaCookieValid() {
  return document.cookie
    .split(";")
    .some(cookie => cookie.trim().startsWith("reminderpwa="));
}
